import peRatio from './valuation/pe-ratio';
import sip from './products/sip';
import nifty50 from './market-concepts/nifty-50';
import ltcg from './tax/long-term-capital-gains';
import stcg from './tax/short-term-capital-gains';
import { categories } from './categories';

const allTerms = [peRatio, sip, nifty50, ltcg, stcg].filter(t => t && t.slug);

function getTermBySlug(slug) {
  return allTerms.find(t => t.slug === slug) || null;
}

function getTermsByCategory(categorySlug) {
  return allTerms.filter(t => t.category === categorySlug);
}

function searchTerms(query) {
  const q = query.toLowerCase().trim();
  if (!q) return allTerms;
  return allTerms.filter(t =>
    t.title?.toLowerCase().includes(q) ||
    t.fullTitle?.toLowerCase().includes(q) ||
    t.quickDefinition?.toLowerCase().includes(q) ||
    t.plainEnglish?.toLowerCase().includes(q) ||
    t.category?.toLowerCase().includes(q)
  );
}

export { allTerms, categories, getTermBySlug, getTermsByCategory, searchTerms };
